function getSizeScroll() {
  var sizeElement= document.getElementsByClassName('select-items')[0];
  if (sizeElement.scrollHeight > sizeElement.clientHeight) {
    sizeElement.classList.add('remove-border');
  }
}

var sizeElementSelected = document.getElementsByClassName('select-selected')[0];
if (typeof sizeElementSelected !== 'undefined') {
  sizeElementSelected.addEventListener("click", (e) => {
    setTimeout(getSizeScroll, 100)
  })
}